<template>
    <div class="establishModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="establishBox">
           <div class="title">填写核销数量</div>
           <div class="oneArea">
               <!-- <div class="oneline"><span class="mylabel">下单订单号：</span><span class="text">{{infoObj.orderId}}</span></div> -->
               <div class="oneline"><span class="mylabel">商品款号：</span><span class="text">{{infoObj.itemId}}</span></div>
           </div>
           <div class="oneArea">
               <div class="oneline"><span class="mylabel">总共可核销数量：</span><span class="text">{{infoObj.totalEstablish}}件</span></div>
               <div class="oneline"><span class="mylabel">累计已核销数量：</span><span class="text">{{infoObj.haveEstablishTotal}}件</span></div>
               <div class="oneline"><span class="mylabel">剩余未核销数量：</span><span class="text red">{{infoObj.leftEstablishTotal}}件</span></div>
           </div>
           <div class="oneArea">
               <div class="oneline">
                   <span class="mylabel">本次核销数量：</span>
                   <input type="text" placeholder="请输入数字" v-model="number">
               </div>
           </div>
           <div class="footer">
               <button class="closeBtn btn" @click="closeModal">取消</button>
               <button class="submitBtn btn" @click="submitClick">确定</button>
           </div>
       </div>
       
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { saveOrderEstablish} from '../api/dealer'
    export default {
      name: 'hexiao',
      props: ["info"],
      computed: {
        ...mapState({
          userId: state => state.user.userId
        }),
        infoObj(){
            return this.info
        }
      },
      data () {
        return {
            number:"",
        }
      },
      watch: {
      },
      methods: {
          closeModal(){
              this.number=''
              this.$emit("close")
          },
          closeModalAndSuccess(){
              this.number=''
              this.$emit("success")
          },
          submitClick(){
              let _this=this
              let arg={
                  supplierUserId:_this.infoObj.supplierUserId,
                  dealerUserId:_this.userId,
                  establishOrderInfo:"",//核销订单数据json文本（颜色、尺码、数量等）
                  orderEstablishQuantity:_this.number,
                  itemId:_this.infoObj.itemId,
                  orderId:_this.infoObj.orderId,
              }
              console.log(arg)
              if(!this.number){
                  this.$message.error('核销数量不能为空')
              }else if(this.number<=0){
                  this.$message.error('核销数量不能为0')
              }else if(isNaN(this.number) ){
                  this.$message.error('核销数量只能为数字')
              }else if(this.number>_this.infoObj.leftEstablishTotal){
                  this.$message.error('核销数量不能超过剩余总数')
              }else{
                  saveOrderEstablish(arg).then(res =>{
                      console.log(res)
                      if(res.errorCode==200){
                          this.$message.success("核销成功")
                          _this.closeModalAndSuccess()
                      }else{
                          this.$message.error(res.errorMsg)
                      }
                  })
              }
          }
      },
      mounted() {
        
      }
    }
</script>

<style scoped lang="scss">
.establishModalWrap{
    position: fixed;
    top:0;left:0;right:0;bottom:0; 
    z-index:100;
    .mask{
        background:rgba(0,0,0,0.5);
        position: fixed;
        top:0;left:0;right:0;bottom:0;
    }
    .establishBox{
        position: fixed;z-index:1000;
        left:33%;top:20%;
        width: 30%;min-width: 300px; border:1px solid #eee;border-radius: 4px;
        background: #fff;border-radius: 2px;
        input{border:1px solid #ddd;border-radius: 4px;padding:8px;}
        .title{
            font-size: 18px;
            padding:19px 25px;
            border-bottom: 1px solid #eee;
        }
        .oneArea{margin:20px 0;}
        .oneline{margin:10px 0;padding:0 25px;}
        .mylabel{}
        .text{}
        
        .footer{
            text-align: right;
            border-top: 1px solid #eee;
            padding:14px 25px;
            .btn{padding:5px 16px;background: #fff;font-size: 12px;border-radius: 4px;}
            .closeBtn{margin-right: 10px;border:1px solid #D9D9D9;}
            .submitBtn{background: #F81D22;color:#fff;border:0;}
        }
    }
}
</style>